module.exports = __webpack_public_path__ + "static/buddha-1641a5f5135f4940cdbf329a733a9bb1.png";